import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const boxTabDefaultVariants = {
  "size": "md",
  "fill": false
}
const boxTabCompoundVariants = []

const boxTabSlotNames = [
  [
    "root",
    "boxTab__root"
  ],
  [
    "listWrapper",
    "boxTab__listWrapper"
  ],
  [
    "list",
    "boxTab__list"
  ],
  [
    "item",
    "boxTab__item"
  ],
  [
    "handle",
    "boxTab__handle"
  ],
  [
    "label",
    "boxTab__label"
  ],
  [
    "count",
    "boxTab__count"
  ],
  [
    "endSlot",
    "boxTab__endSlot"
  ],
  [
    "panel",
    "boxTab__panel"
  ],
  [
    "scrollButton",
    "boxTab__scrollButton"
  ],
  [
    "scrollDim",
    "boxTab__scrollDim"
  ]
]
const boxTabSlotFns = /* @__PURE__ */ boxTabSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, boxTabDefaultVariants, getSlotCompoundVariant(boxTabCompoundVariants, slotName))])

const boxTabFn = memo((props = {}) => {
  return Object.fromEntries(boxTabSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const boxTabVariantKeys = [
  "size",
  "fill"
]
const getVariantProps = (variants) => ({ ...boxTabDefaultVariants, ...compact(variants) })

export const boxTab = /* @__PURE__ */ Object.assign(boxTabFn, {
  __recipe__: false,
  __name__: 'boxTab',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: boxTabVariantKeys,
  variantMap: {
  "size": [
    "sm",
    "md",
    "lg"
  ],
  "fill": [
    "true",
    "false"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, boxTabVariantKeys)
  },
  getVariantProps
})